
import React from 'react';
import { ContactUs } from './ContactUs';
import { EnquirePanel } from './EnquirePanel';
import { ArcaComponent } from '../../pages/ArcaComponent';
import { Row, Col } from 'reactstrap';

export class ContactPanel extends ArcaComponent {

    render() {

        return (
            <div className='rounded px-3 px-sm-4 py-3 py-sm-5 article topAndBottomPanels' id='#enquire'>
                <Row>
                    {/* <a href='#top' >Top</a> */}
                    <Col>
                        <EnquirePanel />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ContactUs />
                    </Col>
                </Row>
            </div>
        )
    }
}